module.exports = __webpack_public_path__ + "static/media/ovantad.9c16e3bf.mp3";